﻿import { UTL } from "../util/classes";
import { PopupPlusStyleRecord, PopupPlusAuxFunctions } from "./popupPlus_Aux"; // <--- ייבוא הפונקציה הספציפית

export class PromptPlus {
    private static IS_INITIALZED: boolean = false;
    private static overlay_element: HTMLDivElement = null;
    private static popup_element: HTMLDivElement = null;
    private static caption_element: HTMLDivElement = null;
    private static text_element: HTMLDivElement = null;

    // מסוג אחר input_element כי אולי בעתיד יהיו input_element ולא רק במילה prompt_input_element אנחנו משתמשים במילה
    // מסוג אחר input_element כי אולי בעתיד יהיו input_element ולא רק במילה prompt_input_element אנחנו משתמשים במילה
    // מסוג אחר input_element כי אולי בעתיד יהיו input_element ולא רק במילה prompt_input_element אנחנו משתמשים במילה
    private static prompt_input_element: HTMLInputElement = null;


    private static panel_element: HTMLDivElement = null;
    private static ok_button_element: HTMLButtonElement = null;
    private static cancel_button_element: HTMLButtonElement = null;

    public static resolve_function_pointer: Function = null; // ומשתנה זה רק שומר מצביע אליה executor_function כדי להזכיר שזאת לא פונקציה שלנו אלא פונקציה שקיבלנו מאת ה "_pointer" הוספנו את המילה
    public static par_caption_str: string = "";
    public static par_text_str: string = "";
    //public static par_caption_exist: boolean = false;
    public static par_start_of_input_str: string = "";
    public static par_style_rec: PopupPlusStyleRecord = null;

    private static overlay_keydown(event: KeyboardEvent): void {
        if (PopupPlusAuxFunctions.keydown_event_should_preventDefault(event) == true) {
            event.preventDefault(); // לשים את הפקודה הזאת gemini :הערה
            event.stopPropagation(); // לשים את הפקודה הזאת gemini :הערה
        }
        if (event.key === 'Tab') {
            if (event.shiftKey == false) {
                //alert("Tab");
                //PromptPlus.ok_button_element.focus();
                UTL.MOVE_FOCUS_Forward(PromptPlus.prompt_input_element, PromptPlus.ok_button_element, PromptPlus.cancel_button_element)
            }
            if (event.shiftKey == true) {
                //alert("Shift+Tab");
                UTL.MOVE_FOCUS_Forward(PromptPlus.prompt_input_element, PromptPlus.cancel_button_element, PromptPlus.ok_button_element)
            }
        }

        if (event.key === 'Enter') {
            if (document.activeElement === PromptPlus.ok_button_element) {
                PromptPlus.perform_ok();
            }
            if (document.activeElement === PromptPlus.cancel_button_element) {
                PromptPlus.perform_cancel();
            }
        }
        if (event.key === 'Escape') {
            PromptPlus.perform_cancel();
        }
    }


    static overlay_mousedown(event: MouseEvent) {
        //---------------------------------------------------------------------------------------------
        //                               ."event.preventDefault();" שים לב. אנחנו מפעילים באירוע הזה את
        // למה? בגלל שאם לא מבצעים זאת אז לחיצה על העכבר במקום כלשהו גורמת לפוקוס לעבור למקום אחר כלשהו
        //---------------------------------------------------------------------------------------------
        event.preventDefault();
        //PromptPlus.ok_button_element.focus();
    }

    private static perform_INITIALZE_INA() {
        const freezed_IS_INITIALZED: boolean = PromptPlus.IS_INITIALZED;
        if (freezed_IS_INITIALZED == false) {
            PromptPlus.overlay_element = document.createElement("div");;
            PromptPlus.popup_element = document.createElement("div");;
            PromptPlus.caption_element = document.createElement("div");;
            PromptPlus.text_element = document.createElement("div");;
            // מסוג אחר input_element כי אולי בעתיד יהיו input_element ולא רק במילה prompt_input_element אנחנו משתמשים במילה
            // מסוג אחר input_element כי אולי בעתיד יהיו input_element ולא רק במילה prompt_input_element אנחנו משתמשים במילה
            PromptPlus.prompt_input_element = document.createElement("input");;
            //PromptPlus.prompt_input_element.value = "hello";
            PromptPlus.panel_element = document.createElement("div");;
            PromptPlus.ok_button_element = document.createElement("button");;
            PromptPlus.cancel_button_element = document.createElement("button");;
            //-----------------------------
            PromptPlus.overlay_element.appendChild(PromptPlus.popup_element);
            PromptPlus.popup_element.appendChild(PromptPlus.caption_element);
            PromptPlus.popup_element.appendChild(PromptPlus.text_element);
            PromptPlus.popup_element.appendChild(PromptPlus.prompt_input_element);
            PromptPlus.popup_element.appendChild(PromptPlus.panel_element);
            PromptPlus.panel_element.appendChild(PromptPlus.ok_button_element);
            PromptPlus.panel_element.appendChild(PromptPlus.cancel_button_element);
            //-----------------------------
            PromptPlus.ok_button_element.addEventListener("click", PromptPlus.perform_ok);
            PromptPlus.cancel_button_element.addEventListener("click", PromptPlus.perform_cancel);
            PromptPlus.overlay_element.addEventListener("keydown", PromptPlus.overlay_keydown);
            PromptPlus.overlay_element.addEventListener("mousedown", PromptPlus.overlay_mousedown);
            //-----------------------------

            PromptPlus.IS_INITIALZED = true;
        }
    }

    private static perform_ok(): void {
        //UTL.show_which_element_has_focus();

        document.body.removeChild(PromptPlus.overlay_element);
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        const result_str = PromptPlus.prompt_input_element.value;
        PromptPlus.resolve_function_pointer(result_str);
        PromptPlus.resolve_function_pointer = null; // כדי שלא נקרא בפעם אחרת בטעות לפונקציה ישנה  
    }

    private static perform_cancel(): void {
        //UTL.show_which_element_has_focus();

        document.body.removeChild(PromptPlus.overlay_element);
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        // אבל בינתיים זה עובד בלי זה. יש לזכור הערה זו למידה ויהיו בעיות setTimeout() באמצעות  resolve_function בעקרון אני חושב/חשבתי שצריך לקרוא ל
        PromptPlus.resolve_function_pointer(null);
        PromptPlus.resolve_function_pointer = null; // כדי שלא נקרא בפעם אחרת בטעות לפונקציה ישנה  
    }

    public static prepare(): void {
        PromptPlus.perform_INITIALZE_INA();

        if (true) {

            PopupPlusAuxFunctions.apply_style_to_overlay_element(PromptPlus.overlay_element, PromptPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_popup_element(PromptPlus.popup_element, PromptPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_caption_element(PromptPlus.caption_element, PromptPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_text_element(PromptPlus.text_element, PromptPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_prompt_input_element(PromptPlus.prompt_input_element, PromptPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_panel_element(PromptPlus.panel_element, PromptPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_ok_button_element(PromptPlus.ok_button_element, PromptPlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_cancel_button_element(PromptPlus.cancel_button_element, PromptPlus.par_style_rec);
        }

        if (true) {
            if (PromptPlus.par_caption_str == null) {
                PromptPlus.caption_element.style.display = "none";
            }
            if (PromptPlus.par_caption_str != null) {
                PromptPlus.caption_element.style.display = "block";
            }
        }
        if (true) {
            PromptPlus.caption_element.innerText = PromptPlus.par_caption_str;
            //PromptPlus.text_element.innerText = PromptPlus.par_text_str;
            PromptPlus.text_element.innerHTML = PromptPlus.par_text_str; //innerHTML ל innerText שינינו מ
            //PromptPlus.text_element.style.fontSize = PromptPlus.par_style_rec.text_element_fontSize;
            debugger;
            PromptPlus.prompt_input_element.value = PromptPlus.par_start_of_input_str;
        }

    }

    public static executor_function(p_resolve: Function, p_reject: Function): void {
        //debugger;
        // כדי לא להתבלבל עם מחלקות אחרות. בהמשך יש כנראה להוריד את זה "PromptPlus_" הוספנו כאן את הקידומת
        // כדי לא להתבלבל עם מחלקות אחרות. בהמשך יש כנראה להוריד את זה "PromptPlus_" הוספנו כאן את הקידומת
        // כדי לא להתבלבל עם מחלקות אחרות. בהמשך יש כנראה להוריד את זה "PromptPlus_" הוספנו כאן את הקידומת
        PromptPlus.resolve_function_pointer = p_resolve;
        PromptPlus.prepare();
        document.body.appendChild(PromptPlus.overlay_element);
        UTL.center_popup_element_inside_overlay_element(PromptPlus.popup_element, PromptPlus.overlay_element);
        // onfocus,onblur אמר שכנראה האינדיקציה לאיזה כפתור יש את הפוקוס אינה אמינה ולכן אנחנו מיישמים אתgemini לזכירך
        // onfocus,onblur אמר שכנראה האינדיקציה לאיזה כפתור יש את הפוקוס אינה אמינה ולכן אנחנו מיישמים אתgemini לזכירך
        // onfocus,onblur אמר שכנראה האינדיקציה לאיזה כפתור יש את הפוקוס אינה אמינה ולכן אנחנו מיישמים אתgemini לזכירך
        //PromptPlus.cancel_button_element.focus();
        //PromptPlus.ok_button_element.focus();
        PromptPlus.prompt_input_element.focus();
    }


    public static ShowAsync(p_text_str: string, p_start_of_input_str: string, p_caption_str: string = null, p_style_rec: PopupPlusStyleRecord = null): Promise<string> {
        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה
        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה

        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה

        if (p_style_rec != null && (p_style_rec instanceof PopupPlusStyleRecord) == false) {
            alert("PromptPlus.p_style_rec is not PopupPlusStyleRecord");
            return;
        }
        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        PromptPlus.par_text_str = p_text_str;
        PromptPlus.par_start_of_input_str = p_start_of_input_str;
        PromptPlus.par_caption_str = p_caption_str;
        PromptPlus.par_style_rec = p_style_rec;
        if (PromptPlus.par_style_rec == null) {
            PromptPlus.par_style_rec = PopupPlusAuxFunctions.create_rec_style_v1("ltr", "20px", false);
        }
        return new Promise(PromptPlus.executor_function);
    }

}
